import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Disable browser's automatic scroll restoration to prevent scroll position issues
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PERFORMANCE: Web Vitals monitoring for performance metrics
// SECURITY: No console logging - metrics can be sent to analytics in production
// The web-vitals library is dynamically imported to prevent blocking initial load
reportWebVitals((metric) => {
  // SECURITY: Metrics are collected but not logged to console
  // In production, these can be sent to analytics endpoint if needed
  
  // Optional: Send to analytics endpoint in production
  // Uncomment and configure analytics endpoint when ready
  // if (process.env.NODE_ENV === 'production') {
  //   fetch('/api/analytics/vitals', {
  //     method: 'POST',
  //     body: JSON.stringify(metric),
  //     headers: { 'Content-Type': 'application/json' }
  //   }).catch(() => {
  //     // SECURITY: Silent fail - don't log errors to prevent information leakage
  //   });
  // }
});

// Register service worker for offline support and caching
// DISABLED IN DEVELOPMENT: Service worker is disabled in dev mode to prevent caching issues
if ('serviceWorker' in navigator) {
  // In development, unregister any existing service workers to prevent caching
  if (process.env.NODE_ENV === 'development') {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().catch(() => {
          // Silent fail
        });
      });
    });
  } else {
    // Only register service worker in production
    navigator.serviceWorker
      .register('/sw.js', {
        scope: '/',
        updateViaCache: 'none' // Always check for updates
      })
    .then((registration) => {
      // SECURITY: Removed console.log to prevent information leakage
      
      // Check for updates periodically
      setInterval(() => {
        registration.update();
      }, 60 * 60 * 1000); // Check every hour
      
      // Handle service worker updates
      // Updates will be applied automatically on next page refresh (silent update)
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker available - will activate on next page refresh
              // SECURITY: No notification shown, no information leaked
            }
          });
        }
      });
    })
    .catch((error) => {
      // Log errors in development for debugging
      if (process.env.NODE_ENV === 'development') {
        // SECURITY: Removed console.error to prevent information leakage
      }
      // Silent fail in production to avoid user-facing errors
    });
    
    // Listen for controller changes (when new SW takes control)
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      // Optionally reload the page when new service worker takes control
      // window.location.reload();
    });
  }
}

// PERFORMANCE: Prefetch categories on app initialization for instant hamburger menu
// This makes the category menu load instantly on first interaction
if (typeof window !== 'undefined') {
  // Prefetch in background (non-blocking)
  setTimeout(() => {
    import('./services/firebaseConfig').then(({ categoryService }) => {
      categoryService.getTopLevelCategories()
        .then(categories => {
          // Cache immediately in localStorage for instant access
          try {
            localStorage.setItem('categories_topLevel', JSON.stringify({
              data: categories,
              timestamp: Date.now()
            }));
          } catch (e) {
            // localStorage might be full or disabled, continue silently
          }
        })
        .catch(() => {
          // Silent fail - will fetch normally when needed
        });
    }).catch(() => {
      // Silent fail if import fails
    });
  }, 100); // Small delay to not block initial render
}

// PERFORMANCE OPTIMIZATION NOTE:
// Previous implementations preloaded banners and other homepage data here.
// With banners removed, homepage data is now fetched directly within page components.